if (!customElements.get('pot-addon-item')) {
  customElements.define(
    'pot-addon-item',
    class PotAddonItem extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.controls = this.querySelector('.pot-addon__controls');
        this.addTemplate = this.querySelector('.pot-addon__add-template');
        this.stepperTemplate = this.querySelector('.pot-addon__stepper-template');
        this.addEventListener('click', this.onControlClick.bind(this));
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      }

      onCartUpdate(event) {
        if (event.source === 'pot-addon-self') return;
        if (String(event.productVariantId) !== String(this.variantId)) return;
        this.showStepper(1);
      }

      onControlClick(evt) {
        const button = evt.target.closest('[data-pot-action]');
        if (!button) return;
        evt.preventDefault();
        const qtyEl = this.querySelector('.pot-addon__qty-value');
        const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
        const newQty = button.dataset.potAction === 'increase' ? currentQty + 1 : currentQty - 1;
        this.changeQuantity(newQty);
      }

      changeQuantity(qty) {
        if (qty < 0) qty = 0;
        const config = fetchConfig('json');
        config.body = JSON.stringify({ id: this.variantId, quantity: qty, sections: 'cart-icon-bubble' });

        fetch(window.routes.cart_change_url, config)
          .then((res) => res.json())
          .then((cart) => {
            if (qty <= 0) {
              this.showAdd();
            } else {
              this.showStepper(qty);
            }

            const bubble = document.getElementById('cart-icon-bubble');
            if (bubble && cart.sections && cart.sections['cart-icon-bubble']) {
              bubble.innerHTML = cart.sections['cart-icon-bubble'];
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'pot-addon-self',
              productVariantId: this.variantId,
              cartData: cart,
            });
          })
          .catch((e) => console.error(e));
      }

      showStepper(qty) {
        if (!this.stepperTemplate) return;
        const frag = this.stepperTemplate.content.cloneNode(true);
        const qtyValue = frag.querySelector('.pot-addon__qty-value');
        if (qtyValue) qtyValue.textContent = qty;
        this.controls.replaceChildren(frag);
      }

      showAdd() {
        if (!this.addTemplate) return;
        this.controls.replaceChildren(this.addTemplate.content.cloneNode(true));
      }
    }
  );
}
